<div class="input-group vertical custom-input-group required">
  <h6 class="group-header">Need additional information or have a question? Please submit and we will get back to you as soon as possible.</h6>
  <section *ngIf="!user || !user.email || (user.email.indexOf('@') < 1)" class="form-group">
    <h6 class="group-header">Your email:</h6>
    <input type="text" [(ngModel)]="newEmail" placeholder="email" name="email"/>
  </section>
  <textarea class="form-control custom-form-control ta-width-100" rows="7" [(ngModel)]="question" [ngModelOptions]="{standalone: true}"></textarea>
</div>
<button type="button" class="btn btn-primary float-right" (click)="send()" [disabled]="saving">Send question</button>
